<template>
    <section id="form_section">
        <div class="container">
            <div class="avr_header">
                <h1 class="avr_title">Конфігуратор АВР</h1>
                <a href="javascript:void(0)" v-on:click="modal_info = true" class="info_btn">
                    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path id="info-icon" d="M9.5 5H11.5V7H9.5V5ZM9.5 9H11.5V15H9.5V9ZM10.5 0C4.98 0 0.5 4.48 0.5 10C0.5 15.52 4.98 20 10.5 20C16.02 20 20.5 15.52 20.5 10C20.5 4.48 16.02 0 10.5 0ZM10.5 18C6.09 18 2.5 14.41 2.5 10C2.5 5.59 6.09 2 10.5 2C14.91 2 18.5 5.59 18.5 10C18.5 14.41 14.91 18 10.5 18Z" fill="#356EEF"/>
                    </svg>
                    Опис роботи сервісу
                </a>
            </div>

            <div class="avr_content">
                <ul class="avr_tabs">
                    <li v-if="prevTabActive" class="next">
                        <a href="javascript:void(0)" class="prev_btn" v-on:click="prevTab()">
                            <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1.99984 0L0.589844 1.41L5.16984 6L0.589844 10.59L1.99984 12L7.99984 6L1.99984 0Z" fill="black"/>
                            </svg>
                        </a>
                    </li>
                    <li v-for="(tab, i) in tabsArr" :key="`tab_${i}`" v-on:click="active_tab = tab.slug" class="avr_tab" :class="{ 'active': active_tab == tab.slug }"><span v-html="tab.title"></span></li>
                    <li v-if="nextTabActive" class="next">
                        <a href="javascript:void(0)" v-on:click="nextTab()">
                            <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1.99984 0L0.589844 1.41L5.16984 6L0.589844 10.59L1.99984 12L7.99984 6L1.99984 0Z" fill="black"/>
                            </svg>
                        </a>
                    </li>
                </ul>
                <div class="tab_content">
                    <div class="tab_content__header">
                        <div class="tab_content__header__row">
                            <div class="nominal_power">
                                <p class="title">Номінальний струм АВР, А</p>
                                <select class="nominal_select" v-model="nominal_power">
                                    <option :value="null" disabled>Вибрати</option>
                                    <option v-for="(nominal_p, i) in nominal_powers" :key="`value_${i}`" :value="nominal_p">{{ nominal_p }}</option>
                                </select>
                            </div>
                            <div class="dg_switcher" v-if="active_tab !== 'avr_100_kontaktori'">
                                <label class="toggle">
                                    <input class="toggle__checkbox" v-model="dg" type="checkbox">
                                    <span class="toggle__switch"></span>
                                    <span class="title">Додати Ввід 3. Дизель генератор</span>
                                </label>
                            </div>
                        </div>
                        <a href="javascript:void(0)" v-on:click="modal_docs = true" class="btn-download">
                            <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path id="download-icon" d="M14 6.5H10V0.5H4V6.5H0L7 13.5L14 6.5ZM0 15.5V17.5H14V15.5H0Z" fill="#356EEF"/>
                            </svg>
                            Документація
                        </a>
                    </div>
                    <div class="result_scheme_conrtainer">
                        <img class="result_scheme" :src="scheme" />
                    </div>
                </div>
            </div>

            <div class="line_switcher">
                <label class="toggle">
                    <input class="toggle__checkbox" v-model="outgoing_lines" type="checkbox">
                    <span class="toggle__switch"></span>
                    <span class="title">Додати відхідні лінії</span>
                </label>
            </div>

            <div class="line_table" v-if="outgoing_lines">
                <table style="z-index:1;" border=1>
                    <thead>
                        <th class="ol_num">№</th>
                        <th class="ol_eq">Обладнання</th>
                        <th class="ol_p_ctn">Кількість полюсів</th>
                        <th class="ol_char">Характеристка, виконання</th>
                        <th class="ol_curr">Струм, виконання</th>
                        <th class="ol_cnt">Кількість</th>
                        <th class="ol_article">Артикул</th>
                        <th class="ol_close"></th>
                    </thead>
                    <tbody>
                        <tr v-for="(line_product, i) in line_products" :key="`product_${i}`">
                            <td class="ol_num">{{ i + 1 }}</td>
                            <td class="ol_eq">
                                <div v-if="!isMobile()" class="ol_eq__select">
                                    <CustomSelect
                                        :def="'Вибрати'"
                                        :options="equipments"
                                        class="select"
                                        :value="line_product.equipment"
                                        v-model="line_product.equipment"
                                        @update:modelValue="getArticle(i, true)"
                                    />
                                </div>

                                <select class="option_select" v-on:change="getArticle(i, true)" v-model="line_product.equipment" v-else>
                                    <option :value="null" disabled>Вибрати</option>
                                    <option v-for="(equipment, k) in equipments" :key="`equipment_${k}`" :value="equipment">{{ equipment }}</option>
                                </select>
                            </td>
                            <td class="ol_p_ctn">
                                <div v-if="!isMobile()" class="ol_p_ctn__select">
                                    <CustomSelect
                                        :def="'Вибрати'"
                                        :options="line_product.pole_numbers"
                                        class="select"
                                        :value="line_product.pole_number"
                                        v-model="line_product.pole_number"
                                        @update:modelValue="getArticle(i)"
                                    />
                                </div>
                                <select class="option_select" v-on:change="getArticle(i)" v-model="line_product.pole_number" v-else>
                                    <option :value="null" disabled>Вибрати</option>
                                    <option v-for="(pole_number, k) in line_product.pole_numbers" :key="`pole_number_${k}`" :value="pole_number">{{ pole_number }}</option>
                                </select>
                            </td>
                            <td class="ol_char">
                                <div v-if="!isMobile()" class="ol_char__select">
                                    <CustomSelect
                                        :def="'Вибрати'"
                                        :options="line_product.characteristics"
                                        class="select"
                                        :value="line_product.characteristic"
                                        v-model="line_product.characteristic"
                                        @update:modelValue="getArticle(i)"
                                    />
                                </div>

                                <select class="option_select" v-on:change="getArticle(i)" v-model="line_product.characteristic" v-else>
                                    <option :value="null" disabled>Вибрати</option>
                                    <option v-for="(characteristic, k) in line_product.characteristics" :key="`characteristic_${k}`" :value="characteristic">{{ characteristic }}</option>
                                </select>
                            </td>
                            <td class="ol_curr">
                                <div v-if="!isMobile()" class="ol_curr__select">
                                    <CustomSelect
                                        :def="'Вибрати'"
                                        :options="line_product.powers"
                                        class="select"
                                        :value="line_product.power"
                                        v-model="line_product.power"
                                        @update:modelValue="getArticle(i)"
                                    />
                                </div>

                                <select class="option_select" v-on:change="getArticle(i)" v-model="line_product.power" v-else>
                                    <option :value="null" disabled>Вибрати</option>
                                    <option v-for="(power, k) in line_product.powers" :key="`power_${k}`" :value="power">{{ power }}</option>
                                </select>
                            </td>
                            <td class="ol_cnt count_td">
                                <div class="count">
                                    <a href="javascript:void(0)" v-on:click="minusProductCount(i)">-</a>
                                    <span>{{ line_product.count }}</span>
                                    <a href="javascript:void(0)" v-on:click="plusProductCount(i)">+</a>
                                </div>
                            </td>
                            <td class="article ol_article"><a :href="line_product.article ? line_product.article.tech_char : null" target="_blank">{{ line_product.article ? line_product.article.article : null }}</a></td>
                            <td class="ol_close">
                                <a href="javascript:void(0)" v-on:click="deleteProduct(i)">
                                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z" fill="#356EEF"/>
                                    </svg>
                                </a>
                            </td>
                        </tr>
                        <tr>
                            <td class="ol_num"></td>
                            <td class="ol_eq">
                                <a href="javascript:void(0)" v-on:click="addProduct()" class="add_btn">
                                    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="13" cy="13" r="13" fill="#356EEF"/>
                                        <g clip-path="url(#clip0_2325_54844)">
                                        <rect width="11" height="20" transform="translate(8 1)" fill="white" fill-opacity="0.01"/>
                                        <path d="M14.012 12.334V8.392H12.788V12.334H8.864V13.558H12.788V17.5H14.012V13.558H17.936V12.334H14.012Z" fill="white"/>
                                        </g>
                                        <defs>
                                        <clipPath id="clip0_2325_54844">
                                        <rect width="11" height="20" fill="white" transform="translate(8 1)"/>
                                        </clipPath>
                                        </defs>
                                    </svg>
                                    <span>Додати</span>
                                </a>
                            </td>
                            <td class="ol_p_ctn"></td>
                            <td class="ol_char"></td>
                            <td class="ol_curr"></td>
                            <td class="ol_cnt"></td>
                            <td class="ol_article"></td>
                            <td class="ol_close"></td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="avr_footer">
                <div class="nominal_power">
                    <p class="title">Металоконструкція</p>
                    <select class="nominal_select metal_constr_select" v-model="metalconstruction">
                        <option :value="null">Ні</option>
                        <option v-for="(metalconstruction_product, i) in metalconstruction_products" :key="`p_${i}`" :value="metalconstruction_product">{{ metalconstruction_product.description }}</option>
                    </select>
                </div>
                <div class="total_btns">
                    <a class="view_spec_btn" :class="{ 'disabled': !nominal_power }" v-on:click="() => {nominal_power ? modal_total = true : false}">Переглянути специфікацію</a>
                    <a class="download_spec" :class="{ 'disabled': !nominal_power }" v-on:click="() => {nominal_power ? getExcel() : false}">Завантажити специфікацію в Excel</a>
                </div>
            </div>
        </div>


        <div class="overlay" v-if="modal_info || modal_docs || modal_total" v-on:click="() => {modal_info = false; modal_docs = false; modal_total = false; summarize = false;}"></div>
        <div class="modal description_modal" v-if="modal_info">
            <div class="modal_container">
                <div class="modal_header">
                    <p class="modal_header_title">Опис роботи сервісу</p>
                    <svg id="close_modal" v-on:click="modal_info = false" width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14 2.26151L12.59 0.709961L7 6.86112L1.41 0.709961L0 2.26151L5.59 8.41266L0 14.5638L1.41 16.1154L7 9.96421L12.59 16.1154L14 14.5638L8.41 8.41266L14 2.26151Z" fill="#356EEF"/>
                    </svg>
                </div>
                <div class="modal_content" v-html="text"></div>
            </div>
        </div>
        <div class="modal docs_modal" v-if="modal_docs">
            <div class="modal_container">
                <div class="modal_header">
                    <div class="nosense"></div>
                    <p class="modal_header_title">Документація</p>
                    <svg id="close_modal" v-on:click="modal_docs = false" width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14 2.26151L12.59 0.709961L7 6.86112L1.41 0.709961L0 2.26151L5.59 8.41266L0 14.5638L1.41 16.1154L7 9.96421L12.59 16.1154L14 14.5638L8.41 8.41266L14 2.26151Z" fill="#356EEF"/>
                    </svg>
                </div>
                <div class="modal_content">
                    <ul class="filelist">
                        <template v-for="(doc, i) in docs">
                        <li :key="`file_${i}`" v-if="doc.title !== 'Контролер АВР для ДГ.pdf'" class="filelist_item">
                            <a :href="doc.url" target="_blank" class="file_item">
                                <svg style="margin-top: 5px;" width="17" height="20" viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M2.5 0C1.4 0 0.51 0.9 0.51 2L0.5 18C0.5 19.1 1.39 20 2.49 20H14.5C15.6 20 16.5 19.1 16.5 18V6L10.5 0H2.5ZM9.5 7V1.5L15 7H9.5Z" fill="#356EEF"/>
                                </svg>

                                <div class="file_item_container">
                                    <span class="file_name">{{ doc.title }} ({{ doc.size }})</span>
                                </div>
                                <div class="download_ico">
                                    <svg width="17" height="20" viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M14 6H10V0H4V6H0L7 13L14 6ZM0 15V17H14V15H0Z" fill="#356EEF"/>
                                    </svg>
                                </div>
                            </a>
                        </li>
                        </template>
                        <template v-if="dg">
                            <template v-for="(doc, i) in docs">
                                <li :key="`file_${i}`" v-if="doc.title === 'Контролер АВР для ДГ.pdf'" class="filelist_item">
                                    <a :href="doc.url" target="_blank" class="file_item">
                                        <svg style="margin-top: 5px;" width="17" height="20" viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M2.5 0C1.4 0 0.51 0.9 0.51 2L0.5 18C0.5 19.1 1.39 20 2.49 20H14.5C15.6 20 16.5 19.1 16.5 18V6L10.5 0H2.5ZM9.5 7V1.5L15 7H9.5Z" fill="#356EEF"/>
                                        </svg>

                                        <div class="file_item_container">
                                            <span class="file_name">{{ doc.title }} ({{ doc.size }})</span>
                                        </div>
                                        <div class="download_ico">
                                            <svg width="17" height="20" viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M14 6H10V0H4V6H0L7 13L14 6ZM0 15V17H14V15H0Z" fill="#356EEF"/>
                                            </svg>
                                        </div>
                                    </a>
                                </li>
                            </template>
                        </template>
                    </ul>
                </div>
            </div>
        </div>

        <div class="modal modal_total" v-if="modal_total">
            <div class="modal_header">
                <p class="modal_header_title">Специфікація</p>
                <svg id="close_modal" v-on:click="() => {modal_total = false; summarize = false;}" width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14 2.26151L12.59 0.709961L7 6.86112L1.41 0.709961L0 2.26151L5.59 8.41266L0 14.5638L1.41 16.1154L7 9.96421L12.59 16.1154L14 14.5638L8.41 8.41266L14 2.26151Z" fill="#356EEF"/>
                </svg>
            </div>
            <div class="modal_content">
                <br>
                <br>

                <template v-if="!summarize">
                <template v-if="metalconstruction">
                <p class="title">Металоконструкція</p>
                <table style="width:100%; z-index:1;" border=1>
                    <thead>
                        <th class="total_key summ_text">#</th>
                        <th class="total_title summ_text">Найменування</th>
                        <th class="total_maker summ_text">Бренд</th>
                        <th class="total_count summ_text">Кількість</th>
                        <th class="total_od summ_text">Од. Вим.</th>
                        <th class="total_price center summ_text">Ціна, грн. без ПДВ</th>
                        <th class="total_summ center summ_text">Сума, грн. без ПДВ</th>
                        <th class="total_tech center summ_text">Посилання на тех. хар.</th>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="total_key">1</td>
                            <td class="total_title">{{ metalconstruction.description }}</td>
                            <td class="total_maker">{{ metalconstruction.maker }}</td>
                            <td class="total_count">{{ metalconstruction.count }}</td>
                            <td class="total_od">шт.</td>
                            <td class="total_price">{{ numberWithSpaces(metalconstruction.price/1.2) }}</td>
                            <td class="total_summ">{{ numberWithSpaces((metalconstruction.price/1.2) * metalconstruction.count) }}</td>
                            <td class="total_tech">
                                <a :href="metalconstruction.tech_char" target="_blank">
                                    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9 5.53711H11V7.53711H9V5.53711ZM9 9.53711H11V15.5371H9V9.53711ZM10 0.537109C4.48 0.537109 0 5.01711 0 10.5371C0 16.0571 4.48 20.5371 10 20.5371C15.52 20.5371 20 16.0571 20 10.5371C20 5.01711 15.52 0.537109 10 0.537109ZM10 18.5371C5.59 18.5371 2 14.9471 2 10.5371C2 6.12711 5.59 2.53711 10 2.53711C14.41 2.53711 18 6.12711 18 10.5371C18 14.9471 14.41 18.5371 10 18.5371Z" fill="#356EEF"/>
                                    </svg>
                                </a>
                            </td>
                        </tr>
                        <tr class="totat_tr">
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td class="summ_text summ_point" colspan="2">Сума без ПДВ</td>
                            <td class="summ_text summ_value">{{ summMetalProducts() }}</td>
                            <td></td>
                        </tr>
                        <tr class="totat_tr">
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td class="summ_text summ_point" colspan="2">ПДВ</td>
                            <td class="summ_text summ_value">{{ pdvMetalProducts() }}</td>
                            <td></td>
                        </tr>
                        <tr class="totat_tr">
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td class="summ_text summ_point" colspan="2">Сума з ПДВ</td>
                            <td class="summ_text summ_value">{{ summPdvMetalProducts() }}</td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
                <br>
                <br>
                </template>
                
                <template v-if="avr_products.length">
                <p class="title">АВР</p>
                <table style="width:100%; z-index:1;" border=1>
                    <thead>
                        <th class="total_key summ_text">#</th>
                        <th class="total_title summ_text">Найменування</th>
                        <th class="total_maker summ_text">Бренд</th>
                        <th class="total_count summ_text">Кількість</th>
                        <th class="total_od summ_text">Од. Вим.</th>
                        <th class="total_price center summ_text">Ціна, грн. без ПДВ</th>
                        <th class="total_summ center summ_text">Сума, грн. без ПДВ</th>
                        <th class="total_tech center summ_text">Посилання на тех. хар.</th>
                    </thead>
                    <tbody>
                        <tr v-for="(avr_product, i) in avr_products" :key="`p_${i}`">
                            <td class="total_key">{{ i + 1 }}</td>
                            <td class="total_title">{{ avr_product.description }}</td>
                            <td class="total_maker">{{ avr_product.maker }}</td>
                            <td class="total_count">{{ avr_product.count }}</td>
                            <td class="total_od">шт.</td>
                            <td class="total_price">{{ numberWithSpaces(avr_product.price/1.2) }}</td>
                            <td class="total_summ">{{ numberWithSpaces((avr_product.price/1.2) * avr_product.count) }}</td>
                            <td class="total_tech">
                                <a :href="avr_product.tech_char" target="_blank">
                                    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9 5.53711H11V7.53711H9V5.53711ZM9 9.53711H11V15.5371H9V9.53711ZM10 0.537109C4.48 0.537109 0 5.01711 0 10.5371C0 16.0571 4.48 20.5371 10 20.5371C15.52 20.5371 20 16.0571 20 10.5371C20 5.01711 15.52 0.537109 10 0.537109ZM10 18.5371C5.59 18.5371 2 14.9471 2 10.5371C2 6.12711 5.59 2.53711 10 2.53711C14.41 2.53711 18 6.12711 18 10.5371C18 14.9471 14.41 18.5371 10 18.5371Z" fill="#356EEF"/>
                                    </svg>
                                </a>
                            </td>
                        </tr>
                        <tr class="totat_tr">
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td class="summ_text summ_point" colspan="2">Сума без ПДВ</td>
                            <td class="summ_text summ_value">{{ summAvrProducts() }}</td>
                            <td></td>
                        </tr>
                        <tr class="totat_tr">
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td class="summ_text summ_point" colspan="2">ПДВ</td>
                            <td class="summ_text summ_value">{{ pdvAvrProducts() }}</td>
                            <td></td>
                        </tr>
                        <tr class="totat_tr">
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td class="summ_text summ_point" colspan="2">Сума з ПДВ</td>
                            <td class="summ_text summ_value">{{ summPdvAvrProducts() }}</td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
                <br>
                <br>
                </template>

                <template v-if="line_products.length && line_products[0].article">
                <p class="title">Відхідні лінії</p>
                <table style="width:100%; z-index:1;" border=1>
                    <thead>
                        <th class="total_key summ_text">#</th>
                        <th class="total_title summ_text">Найменування</th>
                        <th class="total_maker summ_text">Бренд</th>
                        <th class="total_count summ_text">Кількість</th>
                        <th class="total_od summ_text">Од. Вим.</th>
                        <th class="total_price center summ_text">Ціна, грн. без ПДВ</th>
                        <th class="total_summ center summ_text">Сума, грн. без ПДВ</th>
                        <th class="total_tech center summ_text">Посилання на тех. хар.</th>
                    </thead>
                    <tbody>
                        <tr v-for="(line_product, i) in line_products" :key="`p_${i}`">
                            <template v-if="line_product.article">
                            <td class="total_key">{{ i + 1 }}</td>
                            <td class="total_title">{{ line_product.article.description }}</td>
                            <td class="total_maker">{{ line_product.article.maker }}</td>
                            <td class="total_count">{{ line_product.count }}</td>
                            <td class="total_od">шт.</td>
                            <td class="total_price">{{ numberWithSpaces(line_product.article.price/1.2) }}</td>
                            <td class="total_summ">{{ numberWithSpaces((line_product.article.price/1.2) * line_product.count) }}</td>
                            <td class="total_tech">
                                <a :href="line_product.article.tech_char" target="_blank">
                                    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9 5.53711H11V7.53711H9V5.53711ZM9 9.53711H11V15.5371H9V9.53711ZM10 0.537109C4.48 0.537109 0 5.01711 0 10.5371C0 16.0571 4.48 20.5371 10 20.5371C15.52 20.5371 20 16.0571 20 10.5371C20 5.01711 15.52 0.537109 10 0.537109ZM10 18.5371C5.59 18.5371 2 14.9471 2 10.5371C2 6.12711 5.59 2.53711 10 2.53711C14.41 2.53711 18 6.12711 18 10.5371C18 14.9471 14.41 18.5371 10 18.5371Z" fill="#356EEF"/>
                                    </svg>
                                </a>
                            </td>
                            </template>
                        </tr>
                        <tr class="totat_tr">
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td class="summ_text summ_point" colspan="2">Сума без ПДВ</td>
                            <td class="summ_text summ_value">{{ summInputLinesProducts() }}</td>
                            <td></td>
                        </tr>
                        <tr class="totat_tr">
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td class="summ_text summ_point" colspan="2">ПДВ</td>
                            <td class="summ_text summ_value">{{ pdvInputLinesProducts() }}</td>
                            <td></td>
                        </tr>
                        <tr class="totat_tr">
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td class="summ_text summ_point" colspan="2">Сума з ПДВ</td>
                            <td class="summ_text summ_value">{{ summPdvInputLinesProducts() }}</td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
                </template>
                <br>
                <br>
                </template>

                <template v-if="summarize">
                    <table style="width:100%; z-index:1;" border=1>
                        <thead>
                            <th class="total_key summ_text">#</th>
                            <th class="total_title summ_text">Найменування</th>
                            <th class="total_maker summ_text">Бренд</th>
                            <th class="total_count summ_text">Кількість</th>
                            <th class="total_od summ_text">Од. Вим.</th>
                            <th class="total_price center summ_text">Ціна, грн. без ПДВ</th>
                            <th class="total_summ center summ_text">Сума, грн. без ПДВ</th>
                            <th class="total_tech center summ_text">Посилання на тех. хар.</th>
                        </thead>
                        <tbody>
                            <tr v-for="(summarizeRes, i) in summarizeResult" :key="`p_${i}`">
                                <td class="total_key">{{ i + 1 }}</td>
                                <td class="total_title">{{ summarizeRes.description }}</td>
                                <td class="total_maker">{{ summarizeRes.maker }}</td>
                                <td class="total_count">{{ summarizeRes.count }}</td>
                                <td class="total_od">шт.</td>
                                <td class="total_price">{{ numberWithSpaces(summarizeRes.price/1.2) }}</td>
                                <td class="total_summ">{{ numberWithSpaces((summarizeRes.price/1.2) * summarizeRes.count) }}</td>
                                <td class="total_tech">
                                    <a :href="summarizeRes.tech_char" target="_blank">
                                        <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M9 5.53711H11V7.53711H9V5.53711ZM9 9.53711H11V15.5371H9V9.53711ZM10 0.537109C4.48 0.537109 0 5.01711 0 10.5371C0 16.0571 4.48 20.5371 10 20.5371C15.52 20.5371 20 16.0571 20 10.5371C20 5.01711 15.52 0.537109 10 0.537109ZM10 18.5371C5.59 18.5371 2 14.9471 2 10.5371C2 6.12711 5.59 2.53711 10 2.53711C14.41 2.53711 18 6.12711 18 10.5371C18 14.9471 14.41 18.5371 10 18.5371Z" fill="#356EEF"/>
                                        </svg>
                                    </a>
                                </td>
                            </tr>
                            <tr class="totat_tr">
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td class="summ_text summ_point" colspan="2">Сума без ПДВ</td>
                                <td class="summ_text summ_value">{{ summarizeResultPrice }}</td>
                                <td></td>
                            </tr>
                            <tr class="totat_tr">
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td class="summ_text summ_point" colspan="2">ПДВ</td>
                                <td class="summ_text summ_value">{{ pdvResultPrice }}</td>
                                <td></td>
                            </tr>
                            <tr class="totat_tr">
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td class="summ_text summ_point" colspan="2">Сума з ПДВ</td>
                                <td class="summ_text summ_value">{{ summPdvResultPrice }}</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </template>
            </div>
            <div class="modal_bottom">
                <a href="javascript:void(0)" v-on:click="() => {modal_total = false; summarize = false;}" class="modal_bottom_link">Повернутись до конфігуратора</a>
                <div class="modal_bottom__btns">
                    <a href="javascript:void(0)" v-on:click="doSummarize()" class="avr_summ_btn">
                        <span v-if="!summarize">Підсумувати</span>
                        <span v-if="summarize">Розділити</span>
                    </a>
                    <a href="javascript:void(0)" v-on:click="getExcel()" class="avr_excel_btn">Завантажити Excel</a>
                </div>
            </div>
            <div class="commercial_offer">
                <div class="commercial_offer_header" @click="dropCommercialOfferForm()">
                    <span class="commercial_offer_header_title">Замовити комерційну пропозицію</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" :class="{commercial_offer_drop_row: is_drop_commercial_offer}">
                        <g clip-path="url(#clip0_7979_151607)">
                            <path d="M16.59 8.58984L12 13.1698L7.41 8.58984L6 9.99984L12 15.9998L18 9.99984L16.59 8.58984Z" fill="#356EEF"/>
                        </g>
                        <defs>
                            <clipPath id="clip0_7979_151607">
                            <rect width="24" height="24" fill="white" transform="matrix(-1 0 0 1 24 0)"/>
                            </clipPath>
                        </defs>
                    </svg>
                </div>
                <div class="commercial_offer_body" v-if="is_drop_commercial_offer">
                    <p class="commercial_offer_body_subtitle">Заповніть форму</p>
                    
                    <div class="flex-group customer_info">
                        <div class="flex_form">
                            <div class="flex-row">
                                <div class="form_grid">
                                    <div class="form_group">
                                        <label class="form_label">Організація</label>
                                        <input class="form_input" :class="{ 'border-danger': commercialOfferDataErrors.organization }" v-model="commercialOfferData.organization" type="text" placeholder="Назва" />
                                    </div>
                                    <div class="form_group">
                                        <label class="form_label">Контактна особа</label>
                                        <input class="form_input" v-model="commercialOfferData.name" type="text" placeholder="ПІБ" />
                                    </div>
                                </div>
                                <div class="form_grid">
                                    <div class="form_group">
                                        <label class="form_label">Номер телефону *</label>
                                        <input class="form_input" :class="{ 'border-danger': commercialOfferDataErrors.phone }" @input="acceptNumber" v-model="commercialOfferData.phone" type="text" placeholder="+380" />
                                        <p class="error_text" v-if="commercialOfferDataErrors.phone">Обов'язкове поле</p>
                                    </div>
                                    <div class="form_group">
                                        <label class="form_label">Електронна пошта *</label>
                                        <input class="form_input" :class="{ 'border-danger': commercialOfferDataErrors.email }" v-model="commercialOfferData.email" type="text" placeholder="Email" />
                                        <p class="error_text" v-if="commercialOfferDataErrors.email">Обов'язкове поле</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="flex_form">
                            <div class="form_group mr-9">
                                <label class="form_label">Комментар до замовлення</label>
                                <div class="textarea_container">
                                    <textarea v-model="commercialOfferData.comment" class="form_input form_textarea" maxlength="200" rows="5" placeholder="Коментар"></textarea>
                                    <span class="total_words">{{ commercialOfferData.comment ? commercialOfferData.comment.length : 0 }} / 200</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="commercial_offer_order" v-if="commercial_offer_sended">
                        <div class="block_row">
                            <p class="commercial_offer_order_title">Заявка №{{commercial_offer_id}} від</p>
                            <svg id="close_offer" @click="() => {commercial_offer_sended = false; is_disable_commercial_offer_btn = false}" width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M14 2.26151L12.59 0.709961L7 6.86112L1.41 0.709961L0 2.26151L5.59 8.41266L0 14.5638L1.41 16.1154L7 9.96421L12.59 16.1154L14 14.5638L8.41 8.41266L14 2.26151Z" fill="#356EEF"></path>
                            </svg>
                        </div>
                        <p class="commercial_offer_order_title">{{commercial_offer_created_at}}</p>
                        <p class="commercial_offer_order_text">Ваша запит на Комерційну пропозицію  зареєстрований та прийнятий, найближчим часом наш менеджер з Вами зв’яжеться. </p>
                    </div>

                    <a href="javascript:void(0)" v-if="!commercial_offer_sended" :disabled="is_disable_commercial_offer_btn" class="commercial_offer_order_btn" @click="commercialOrder()">
                        <template v-if="is_disable_commercial_offer_btn">
                            Зачекайте... <ProgressSpinner strokeWidth="5" style="width: 30px; height: 30px; margin: 0; margin-left: 30px;" />
                        </template>
                        <template v-else>Замовити</template>
                    </a>
                    <a href="javascript:void(0)" v-else class="commercial_offer_order_btn disabled">
                        Замовити
                    </a>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import PreloadForm from "@/Components/PreloadForm";
import Fieldset from 'primevue/fieldset';
import Dropdown from 'primevue/dropdown';
import RadioButton from 'primevue/radiobutton';
import InputNumber from 'primevue/inputnumber';
import Checkbox from 'primevue/checkbox';
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import ColumnGroup from "primevue/columngroup";
import Button from "primevue/button";
import Dialog from "primevue/dialog";
import Row from "primevue/row";
import axios from "axios";
import CommonLayout from "@/Layouts/CommonLayout";
import Label from '../Jetstream/Label.vue';
import Input from '../Jetstream/Input.vue';
import CustomSelect from "../Components/CustomSelect.vue";
import ProgressSpinner from 'primevue/progressspinner';


export default {
    props: {
        text: {
            type: String,
            required: false,
        }
    },

    components: {
        PreloadForm,
        Fieldset,
        Dropdown,
        RadioButton,
        InputNumber,
        Checkbox,
        TabView,
        TabPanel,
        DataTable,
        Column,
        Button,
        Dialog,
        ColumnGroup,
        Row,
        Input,
        Label,
        CustomSelect,
        ProgressSpinner
    },
    layout: CommonLayout,
    data() {
        return {
            modal_info: false,
            modal_docs: false,
            modal_total: false,

            tabs: [
                {
                    slug: '2_vvoda_kontaktori',
                    title: '2 ввода <br> Контактори',
                },
                {
                    slug: 'peremikach_navantazhennya_kontroler_avr',
                    title: 'Перемикач навантаження <br> Контролер АВР',
                },
                {
                    slug: 'peremikach_navantazhennya_rele_kontrolyu_naprugi',
                    title: 'Перемикач навантаження <br> Реле контролю напруги',
                },
                {
                    slug: 'avtomatichnij_vimikach_kontroler_avr',
                    title: 'Автоматичний вимикач <br> Контролер АВР',
                },
                {
                    slug: 'avtomatichnij_vimikach_rele_kontrolyu_naprugi',
                    title: 'Автоматичний вимикач <br> Реле контролю напруги',
                },
                {
                    slug: 'avr_100_kontaktori',
                    title: 'АВР 100 <br> Контактори',
                }
            ],

            tabsArr: [],
            nextTabActive: false,
            prevTabActive: false,
            tabIndex: 0,
            tabShowCtn: 3,

            metalconstruction: null,
            dg: false,
            outgoing_lines: false,
            scheme: null,
            nominal_powers: [],
            docs: [],
            nominal_power: null,
            is_nominal_changed: true,
            active_tab: '2_vvoda_kontaktori',

            equipments: [],

            avr_products: [],
            metalconstruction_products: [],
            line_products: [],

            summarize: false,
            summarizeResult: [],
            summarizeResultPrice: 0,
            pdvResultPrice: 0,
            summPdvResultPrice: 0,

            payload: false,
            error: false,
            selectedVariant: null,
            formData: {

            },

            is_drop_commercial_offer: false,
            commercial_offer_sended: false,
            is_disable_commercial_offer_btn: false,
            commercial_offer_id: null,
            commercial_offer_created_at: null,
            commercialOfferData: {
                organization: null,
                name: null,
                phone: null,
                email: null,
                comment: null,
            },
            commercialOfferDataErrors: {
                phone: null,
                email: null,
            },
        }
    },

    watch: {
        'active_tab': {
            handler: function() {
                this.is_nominal_changed = false;
                this.nominal_power = null;
                this.getData();
            },
            deep: true
        },
        'dg': {
            handler: function() {
                this.getData();
            },
            deep: true
        },
        'nominal_power': {
            handler: function() {
                if (this.is_nominal_changed) {
                    this.getData();
                }
            },
            deep: true
        },
        'outgoing_lines': {
            handler: function() {
                if (!this.outgoing_lines) {
                    this.line_products = [];
                }
                this.getData();
            },
            deep: true
        }
    },

    mounted() {
        this.getData();

        this.tabsValues();
    },

    methods: {
        nextTab() {
            this.tabIndex++;
            this.tabsValues();

            if (this.tabIndex + this.tabShowCtn + 1 <= this.tabs.length) {
                this.prevTabActive = true;
            } else {
                this.nextTabActive = false;
            }

        },
        prevTab() {
            if (this.tabIndex > 0) {
                this.tabIndex--;
            }
            if (this.tabIndex == 0) {
                this.prevTabActive = false;
            }

            this.tabsValues();

        },
        isMobile() {
            return window.innerWidth <= 1024;
        },
        tabsValues() {
            this.tabsArr = [];
            this.nextTabActive = false;

            let curr = this;

            if (window.innerWidth > 1180) {
                this.tabsArr = this.tabs;
            }

            if (window.innerWidth <= 1180 && window.innerWidth > 440) {
                this.tabShowCtn = 3;

                let initIndex = this.tabIndex;
                if(initIndex > this.tabs.length - this.tabShowCtn){
                    initIndex = this.tabs.length - this.tabShowCtn;
                }
                for(let i = initIndex; i < this.tabShowCtn + initIndex && i < this.tabs.length; i++){
                    curr.tabsArr.push(this.tabs[i]);
                }

                this.nextTabActive = true;
            }

            if (window.innerWidth <= 440) {
                this.tabShowCtn = 1;

                let initIndex = this.tabIndex;
                if(initIndex > this.tabs.length - this.tabShowCtn){
                    initIndex = this.tabs.length - this.tabShowCtn;
                }
                for(let i = initIndex; i < this.tabShowCtn + initIndex && i < this.tabs.length; i++){
                    curr.tabsArr.push(this.tabs[i]);
                }

                this.nextTabActive = true;
            }
        },

        formatBytes(bytes, decimals = 2) {
            if (!+bytes) return '0 Bytes'

            const k = 1024
            const dm = decimals < 0 ? 0 : decimals
            const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

            const i = Math.floor(Math.log(bytes) / Math.log(k))

            return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
        },

        doSummarize() {
            this.summarize = !this.summarize;

            this.summarizeResultPrice = 0;
            this.summarizeResult = [];
            let articles = [];
            let filteredArr = [];

            if (this.metalconstruction) {
                this.summarizeResultPrice += this.metalconstruction.count * (this.metalconstruction.price/1.2);
                filteredArr.push(this.metalconstruction);
            }

            this.avr_products.forEach((value, index) => {
                this.summarizeResultPrice += value.count * (value.price/1.2);

                filteredArr.push(value);
            });
            

            // this.metalconstruction_products.forEach((value, index) => {
            //     this.summarizeResultPrice += value.count * value.price;

            //     this.summarizeResult.push(value);
            // });

            this.line_products.forEach((value, index) => {
                if (value.article) {
                    this.summarizeResultPrice += value.count * (value.article.price/1.2);

                    value.article.count = value.count;

                    filteredArr.push(value.article);
                }
            });

            filteredArr = JSON.parse(JSON.stringify(filteredArr));

            filteredArr.forEach((v, index) => {
                if (v.article) {

                    if (articles.includes(v.article)) {

                        let obj = filteredArr.find((o, i) => {
                            if (o.article === v.article) {
                                filteredArr[i].count = v.count + o.count;
                                // return true; // stop searching
                            }
                        });

                    } else {
                        articles.push(v.article);
                        this.summarizeResult.push(v);
                    }

                } else {
                    this.summarizeResult.push(v);
                }
            });

            this.pdvResultPrice = this.numberWithSpaces((this.summarizeResultPrice * 20) / 100);
            this.summPdvResultPrice = this.numberWithSpaces(this.summarizeResultPrice + ((this.summarizeResultPrice * 20) / 100));

            this.summarizeResultPrice = this.numberWithSpaces(this.summarizeResultPrice);

        },

        getData() {
            this.payload = true;
            this.error = false;
            this.metalconstruction = null;
            axios.post(this.route('api.avr_data'), {
                slug: this.active_tab,
                dg: this.dg,
                nominal_power: this.nominal_power,
                outgoing_lines: this.outgoing_lines,
            })
                .then((result) => {
                    this.selectedVariant = result.data.selected_variant;

                    this.nominal_powers = result.data.nominal_powers;
                    this.docs = result.data.docs;
                    this.scheme = result.data.scheme;
                    this.equipments = result.data.equipments;

                    this.avr_products = result.data.avr_products;
                    this.metalconstruction_products = result.data.metalconstruction_products;

                    this.payload = true;
                    this.is_nominal_changed = true;
                }).catch((error) => {
                    this.error = true;
                     this.is_nominal_changed = true;
                    window.scroll(0, 0);
                })
        },

        addProduct() {
            this.line_products.push({
                equipment: null,
                pole_number: null,
                characteristic: null,
                power: null,
                count: 1,
                article: null,

                equipments: [],
                pole_numbers: [],
                characteristics: [],
                powers: [],
            });

            this.$forceUpdate();
        },

        plusProductCount(key) {
            this.line_products[key].count++;

            this.$forceUpdate();
        },

        minusProductCount(key) {
            if (this.line_products[key].count > 1) {
                this.line_products[key].count--
            }

            this.$forceUpdate();
        },

        deleteProduct(key) {
            this.line_products.splice(key, 1);

            this.$forceUpdate();
        },

        getPolus(i) {
            this.line_products[i].pole_number = null;
            this.line_products[i].pole_numbers = [];

            this.line_products[i].characteristic = null;
            this.line_products[i].characteristics = [];

            this.line_products[i].power = null;
            this.line_products[i].powers = [];

            this.line_products[i].count = 1;
            this.line_products[i].article = null;


            axios.post(this.route('api.avr_get_polus'), {
                equipment: this.line_products[i].equipment,
            })
            .then((result) => {
                this.line_products[i].pole_numbers = result.data;

                if (!result.data.length) {
                    this.line_products[i].pole_numbers = null;
                    this.getChars(i);
                }
            }).catch((error) => {
                console.log(error);
                window.scroll(0, 0);
            })
        },

        getChars(i) {
            this.line_products[i].characteristic = null;
            this.line_products[i].characteristics = [];

            this.line_products[i].power = null;
            this.line_products[i].powers = [];

            this.line_products[i].count = 1;
            this.line_products[i].article = null;

            axios.post(this.route('api.avr_get_chars'), {
                equipment: this.line_products[i].equipment,
                pole_number: this.line_products[i].pole_number,
            })
            .then((result) => {
                this.line_products[i].characteristics = result.data;

                if (result.data.length === 1) {
                    this.line_products[i].characteristic = result.data[0];
                    this.getPowers(i);
                }
            }).catch((error) => {
                console.log(error);
                window.scroll(0, 0);
            })
        },

        getPowers(i) {
            this.line_products[i].power = null;
            this.line_products[i].powers = [];

            this.line_products[i].count = 1;
            this.line_products[i].article = null;

            axios.post(this.route('api.avr_get_powers'), {
                equipment: this.line_products[i].equipment,
                pole_number: this.line_products[i].pole_number,
                char: this.line_products[i].characteristic,
            })
            .then((result) => {
                this.line_products[i].powers = result.data;

                if (result.data.length === 1) {
                    this.line_products[i].power = result.data[0];
                    this.getArticle(i);
                }
            }).catch((error) => {
                console.log(error);
                window.scroll(0, 0);
            })
        },

        getArticle(i, eq = false) {
            this.line_products[i].article = null;

            if (eq) {
                this.line_products[i].pole_number = null;
                this.line_products[i].characteristic = null;
                this.line_products[i].power = null;
            }

            axios.post(this.route('api.avr_get_article'), {
                equipment: this.line_products[i].equipment,
                pole_number: this.line_products[i].pole_number,
                char: this.line_products[i].characteristic,
                power: this.line_products[i].power,
            })
            .then((result) => {
                this.line_products[i].pole_numbers = result.data.poluses;
                this.line_products[i].characteristics = result.data.chars;
                this.line_products[i].powers = result.data.powers;

                if (result.data.auto) {
                    this.line_products[i].pole_number = result.data.autoPolus;
                    this.line_products[i].characteristic = result.data.autoChar;
                    this.line_products[i].power = result.data.autoPower;
                }

                // if (result.data.poluses.length === 1 || !result.data.poluses.length) {
                //     // this.line_products[i].pole_numbers = null;

                //     this.line_products[i].pole_number = result.data.poluses[0] ? result.data.poluses[0] : null;
                // }
                // if (result.data.chars.length === 1 || !result.data.chars.length) {
                //     this.line_products[i].characteristic = result.data.chars[0] ? result.data.chars[0] : null;
                // }
                // if (result.data.powers.length === 1 || !result.data.powers.length) {
                //     this.line_products[i].power = result.data.powers[0] ? result.data.powers[0] : null;
                // }

                // if ( (this.line_products[i].pole_number ||  !this.line_products[i].pole_number) && this.line_products[i].characteristic && this.line_products[i].power) {
                //     this.getArticle(i);
                // }

                this.line_products[i].article = result.data.item;
            }).catch((error) => {
                console.log(error);
                window.scroll(0, 0);
            })
        },

        numberWithSpaces(x) {
            x = parseFloat(x);
            x = x.toFixed(2);
            var parts = x.toString().split(".");
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
            return parts.join(".");
        },

        summAvrProducts() {
            let summ = 0;
            
            this.avr_products.forEach((value, index) => {
                summ += value.count * (value.price/1.2);
            });

            return this.numberWithSpaces(summ);
        },
        pdvAvrProducts() {
            let summ = 0;
            let pdv = 0;
            
            this.avr_products.forEach((value, index) => {
                summ += value.count * (value.price/1.2);
            });

            pdv = (summ * 20) / 100;

            return this.numberWithSpaces(pdv);
        },
        summPdvAvrProducts() {
            let summ = 0;
            let pdv = 0;
            
            this.avr_products.forEach((value, index) => {
                summ += value.count * (value.price/1.2);
            });

            pdv = (summ * 20) / 100;

            return this.numberWithSpaces(summ + pdv);
        },


        summMetalProducts() {
            let summ = 0;

            if (this.metalconstruction) {
                summ = this.metalconstruction.count * (this.metalconstruction.price/1.2);
            }

            return this.numberWithSpaces(summ);
        },
        pdvMetalProducts() {
            let summ = 0;
            let pdv = 0;

            if (this.metalconstruction) {
                summ = this.metalconstruction.count * (this.metalconstruction.price/1.2);
            }

            pdv = (summ * 20) / 100;

            return this.numberWithSpaces(pdv);
        },
        summPdvMetalProducts() {
            let summ = 0;
            let pdv = 0;

            if (this.metalconstruction) {
                summ = this.metalconstruction.count * (this.metalconstruction.price/1.2);
            }

            pdv = (summ * 20) / 100;

            return this.numberWithSpaces(summ + pdv);
        },

        summInputLinesProducts() {
            let summ = 0;
            
            this.line_products.forEach((value, index) => {
                if (value.article) {
                    summ += value.count * (value.article.price/1.2);
                }
            });

            return this.numberWithSpaces(summ);
        },
        pdvInputLinesProducts() {
            let summ = 0;
            let pdv = 0;
            
            this.line_products.forEach((value, index) => {
                if (value.article) {
                    summ += value.count * (value.article.price/1.2);
                }
            });

            pdv = (summ * 20) / 100;

            return this.numberWithSpaces(pdv);
        },
        summPdvInputLinesProducts() {
            let summ = 0;
            let pdv = 0;
            
            this.line_products.forEach((value, index) => {
                if (value.article) {
                    summ += value.count * (value.article.price/1.2);
                }
            });

            pdv = (summ * 20) / 100;

            return this.numberWithSpaces(summ + pdv);
        },

        getExcel() {
            let ids1 = [];
            let ids2 = [];
            let ids3 = [];

            if (this.metalconstruction) {
                ids1.push(this.metalconstruction);
            }

            this.avr_products.forEach((value, index) => {
                ids2.push(value);
            });

            this.line_products.forEach((value, index) => {
                if (value.article) {
                    value.article.count = value.count;

                    ids3.push(value.article);
                }
            });

            axios.post(this.route('api.avr_get_excel'), {
                ids1: ids1,
                ids2: ids2,
                ids3: ids3,
                summarize: this.summarize
            })
            .then((response) => {
                var fileURL = response.data.data;
                    var fileLink = document.createElement('a');
                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', response.data.name);
                document.body.appendChild(fileLink);
                fileLink.click();
            }).catch((error) => {
                console.log(error);
                window.scroll(0, 0);
            })
        },

        dropCommercialOfferForm() {
            this.is_drop_commercial_offer = !this.is_drop_commercial_offer
        },
        acceptNumber() {
            var x = this.commercialOfferData.phone.replace(/\D/g, '').replace('380', '').replace('38', '').match(/(\d{0,2})(\d{0,3})(\d{0,4})/);

            this.commercialOfferData.phone = !x[2] && x[1] ? '+380' + x[1] : (x[1] ? '+38 (0' + x[1] + ') ' : '+380') + x[2] + (x[3] ? '-' + x[3] : '');
        },
        commercialOrder() {
            if (!this.commercialOfferData.phone) {
                this.commercialOfferDataErrors.phone = true;
                return false;
            } else {
                this.commercialOfferDataErrors.phone = false;
            }
            if (!this.commercialOfferData.email || !(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(this.commercialOfferData.email))) {
                this.commercialOfferDataErrors.email = true;
                return false;
            } else {
                this.commercialOfferDataErrors.email = false;
            }

            let ids1 = [];
            let ids2 = [];
            let ids3 = [];

            if (this.metalconstruction) {
                ids1.push(this.metalconstruction);
            }

            this.avr_products.forEach((value, index) => {
                ids2.push(value);
            });

            this.line_products.forEach((value, index) => {
                if (value.article) {
                    value.article.count = value.count;

                    ids3.push(value.article);
                }
            });

            if (!this.is_disable_commercial_offer_btn) {
                this.is_disable_commercial_offer_btn = true;

                axios.post(this.route('make-offer'), {
                    type: 'AvrService',

                    ids1: ids1,
                    ids2: ids2,
                    ids3: ids3,
                    summarize: this.summarize,

                    organization: this.commercialOfferData.organization,
                    phone: this.commercialOfferData.phone,
                    name: this.commercialOfferData.name,
                    email: this.commercialOfferData.email,
                    comment: this.commercialOfferData.comment,
                    total_price: this.summPdvInputLinesProducts(),
                })
                .then((response) => {
                    this.commercial_offer_id = response.data.id;
                    this.commercial_offer_created_at = response.data.created_at;

                    this.commercial_offer_sended = true;

                    this.commercialOfferData.organization = null
                    this.commercialOfferData.name = null
                    this.commercialOfferData.phone = null
                    this.commercialOfferData.email = null
                    this.commercialOfferData.comment = null
                }).catch((error) => {
                    this.is_disable_commercial_offer_btn = false;
                    console.log(error);
                    window.scroll(0, 0);
                })
            }
        }

    }
};
</script>

<style scoped>
::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 15px;
    height: 15px;
    border-bottom: 1px solid #eee; 
    border-top: 1px solid #eee;
}
::-webkit-scrollbar-thumb {
    border-radius: 8px;
    background-color: #C3C3C3;
    border: 2px solid #eee;
}

::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.2); 
} 

a.disabled {
    cursor:not-allowed;
    filter: opacity(0.5);
}

select {
	-moz-appearance: none; 
	-webkit-appearance: none; 
	appearance: none;
    background-color: #fff;
}
#form_section {
    max-width: 1296px;
    margin: 0 auto;
}
.container {
    padding: 80px 25px 0 20px;
}
.avr_header {
    display: flex;
    justify-content: space-between;
}
.avr_title {
    font-style: normal;
    font-weight: 700;
    font-size: 36px;
    line-height: 43px;
    color: #212529;
}
.info_btn {
    width: 251px;
    height: 48px;
    padding: 12px 30px;
    border: 1px solid #356EEF;
    color: #356EEF;
    border-radius: 4px;
    display: flex;
    align-items: center;
    gap: 10px;
}

.overlay {
    z-index: 1;
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    cursor: pointer;
    background: rgba(0, 0, 0, 0.45);
}

.modal {
    position: fixed;
    z-index: 101;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    overflow: hidden;
    z-index: 2;
    width: 466px;
    height: auto;
    padding: 30px 30px 30px 30px;
    background: #FFFFFF;
    box-shadow: 0px 8px 36px rgba(0, 0, 0, 0.16);
    border-radius: 15px;
    z-index: 999;
}

.modal_total {
    width: 90%;
    top: 435px;
    max-width: 1296px;
    height: 80vh;
    overflow: auto;
}

.modal_total .modal_content{
    overflow: auto;
    height: 470px;
    font-size: 14px;
    line-height: 21px;
    margin: 0px;
}
.modal_total .title{
    margin: 0px;
    padding: 0px;
    margin-bottom: 10px;
}

.modal_total table {
    table-layout: fixed;
    font-size: 14px;
    line-height: 21px;
}

.modal_header {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #CED4DA;
    width: 100%;
    padding-bottom: 10px;
    position: relative;
    align-items: center;
}

.modal_header_title {
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 27px;
    text-align: center;
    color: #000000;
    padding: 0;
    margin: 0;
}

.modal_total .modal_header_title {
    font-style: normal;
    font-weight: 400;
    font-size: 30px;
    line-height: 45px;
}

#close_modal {
    cursor: pointer;
}

.modal_content {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #151920;
    margin-top: 14px;
}

@media (max-width: 780px) {
    .container {
        padding: 50px 0 0 0;
    }
    .avr_header {
        flex-direction: column;
    }
}

@media (max-width: 440px) {
    .modal {
        width: 385px;
    }
    .avr_title {
        font-size: 27px;
        line-height: 36px;
    }
}

.avr_content {
    margin-top: 70px;
}

.avr_tabs {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 0;
    margin: 0;
    height: 80px;
}

.avr_tabs li {
    list-style: none;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: #3A3A3A;
    /* width: 100%; */
    padding-left: 22px;
    padding-right: 22px;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.result_scheme_conrtainer {
    display: flex;
    align-items: center;
    justify-content: center;
}

.result_scheme {
    max-width: 700px;
    height: auto;
    width: 100%;
    height: auto;
}

.avr_tabs li.active {
    background: #FFFFFF;
    height: 82px;
    box-shadow: inset 0px 1px 0px #DEE2E6, inset -1px 0px 0px #DEE2E6, inset 1px 0px 0px #DEE2E6;
    border-radius: 4px 4px 0px 0px;
    color: #356EEF;
}

.title {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #212529;
}

.nominal_select {
    padding: 12px 16px;
    width: 200px;
    height: 48px;
    border: 1px solid #CED4DA;
    border-radius: 4px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-image: url("data:image/svg+xml,%3Csvg width='12' height='8' viewBox='0 0 12 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M10.59 0.0898438L6 4.66984L1.41 0.0898438L0 1.49984L6 7.49984L12 1.49984L10.59 0.0898438Z' fill='%23356EEF'/%3E%3C/svg%3E%0A");
    background-repeat: no-repeat;
    background-position: right 0.75rem center;
    background-size: 12px 7px;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #000000;
}

.metal_constr_select {
    width: 260px;
    padding-right: 40px;
}

.toggle {
	 cursor: pointer;
	 display: inline-block;
}
 .toggle__switch {
	 display: inline-block;
	 background: #FFFFFF;
    border: 1.25px solid rgba(0, 0, 0, 0.15);
    border-radius: 20px;
	 width: 40px;
	 height: 20px;
	 position: relative;
	 vertical-align: middle;
	 transition: background 0.25s;
     margin-right: 20px;
}
 .toggle__switch:before, .toggle__switch:after {
	 content: '';
}
 .toggle__switch:before {
    display: block;
    background: linear-gradient(to bottom, #fff 0%, #eee 100%);
    border-radius: 50%;
    box-shadow: 0 0 0 1px rgb(0 0 0 / 25%);
    width: 15px;
    height: 14px;
    position: absolute;
    top: 2px;
    left: 2px;
    transition: left 0.25s;
}
 .toggle:hover .toggle__switch:before {
	 background: linear-gradient(to bottom, #fff 0%, #fff 100%);
	 box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.5);
}
 .toggle__checkbox:checked + .toggle__switch {
	 background: #0D6EFD;
}
 .toggle__checkbox:checked + .toggle__switch:before {
	 left: 21px;
}
 .toggle__checkbox {
	 position: absolute;
	 visibility: hidden;
}
 .toggle__label {
	 margin-left: 5px;
	 position: relative;
	 top: 2px;
}

.btn-download {
    display: flex;
    align-items: center;
    padding: 13px 30px;
    width: 200px;
    height: 48px;
    border: 1px solid #356EEF;
    color: #356EEF;
    border-radius: 4px;
    cursor: pointer;
}
.btn-download:hover {
    background-color: #356EEF;
    color: #fff;
}
.btn-download:hover #download-icon {
    fill: #fff;
}
.btn-download svg{
    margin-right: 15px;
}

.tab_content__header {
    display: flex;
    justify-content: space-between;
}

.tab_content {
    padding: 30px;
    border: 1px solid #DEE2E6;
}

.filelist {
    padding: 0px;
    margin: 0;
    margin-bottom: 24px;
    width: 100%;
    overflow: auto;
    max-height: 245px;
}

.filelist li {
    list-style: none;
    display: flex;
    justify-content: space-between;
    gap: 10px;
    margin-bottom: 5px;
    width: 100%;
    padding: 13px;
    background: rgba(126, 170, 255, 0.2);
    border-radius: 4px;
}

.filelist li a {
    cursor: pointer;
}
.file_item {
    display: flex;
    gap: 17px;
    width: 100%;
    color: #000000;
}

.file_item_container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    border-bottom: 2px solid #2F80ED;
    padding-bottom: 5px;
}

.file_item_container .file_name {
    font-size: 12px;
    line-height: 18px;
}

.download_ico {
    display: flex;
    align-items: center;
}

.download_ico {
    display: flex;
    align-items: center;
}

.tab_content__header__row {
    display: flex;
    gap: 50px;
}

.line_switcher {
    margin-top: 30px;
}

/* .line_switcher .toggle__switch {
    height: 21px;
} */

.total_btns {
    display: flex;
    gap: 30px;
}

.avr_footer {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    margin-top: 40px;
}

.view_spec_btn {
    width: 263px;
    height: 48px;
    background: #356EEF;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.3);
    border-radius: 4px;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    color: #FFFFFF;
    cursor: pointer;
}

.download_spec {
    width: 323px;
    height: 48px;
    background: #FFFFFF;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.3);
    border-radius: 4px;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    color: #000000;
    cursor: pointer;
}

table {
  margin: 0 auto;
}

/* Default Table Style */
table {
  color: #333;
  background: white;
  border: 1px solid grey;
  font-size: 12pt;
  border-collapse: collapse;
}
table thead th,
table tfoot th {
  text-align: start;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #212529;
}
table caption {
  padding:.5em;
}
table th,
table td {
    border: 1px solid #DEE2E6;
}

.line_table {
    margin-top: 35px;
}

.line_table select {
    padding-right: 40px;
}

.line_table thead th {
    height: 72px!important;
}

.line_table tbody tr {
    height: 55px!important;
}

.line_table table {
    table-layout:fixed;
}

.delete_td {
    padding: 22px 10px 24px 20px;
}

.add_btn {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #000000;
    display: flex;
    align-items: center;
    gap: 16px;
}

.option_select {
    outline: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    text-indent: 1px;
    text-overflow: '';
    user-select: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    -webkit-tap-highlight-color: rgba(0,0,0,0);

    background-image: url("data:image/svg+xml,%3Csvg width='12' height='8' viewBox='0 0 12 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M10.59 0.0898438L6 4.66984L1.41 0.0898438L0 1.49984L6 7.49984L12 1.49984L10.59 0.0898438Z' fill='%23356EEF'/%3E%3C/svg%3E%0A");
    background-repeat: no-repeat;
    background-position: right 0.75rem center;
    background-size: 12px 7px;

    border: none;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #000000;
    width: 100%;
}

.count_td {
    padding: 10px 22px 10px 0px;
}

.count_td .count span {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
}

.count_td .count a {
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 25px;
}

.count {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 25px;
    color: #000000;
}

.count a {
    color: #000000;
}

.article {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #356EEF;
}

.article a {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #356EEF;
}

.modal_bottom {
    display: flex;
    justify-content: space-between;
    padding-top: 20px;
    width: 100%;
}

.modal_bottom_link {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    text-decoration-line: underline;
    color: #356EEF;
    cursor: pointer;
}

.modal_bottom__btns {
    display: flex;
    align-items: center;
    gap: 30px;
}

.avr_summ_btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 154px;
    height: 48px;
    background: #356EEF;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.3);
    border-radius: 4px;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: #FFFFFF;
    cursor: pointer;
}

.avr_excel_btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 203px;
    height: 48px;
    background: #FFFFFF;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.3);
    border-radius: 4px;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: #000000;
    cursor: pointer;
}

.total_key {
    width: 22px;
    padding: 0;
    height: 38px;
    padding-right: 22px;
    text-align: center;
}
.total_title {
    width: 140px;
    padding: 0;
    padding-right: 22px;
    height: 38px;
}
.total_maker {
    width: 62px;
    padding: 0;
    padding-right: 22px;
    height: 38px;
}
.total_count {
    width: 30px;
    text-align: center;
    padding-right: 22px;
    height: 38px;
}
.total_od {
    width: 30px;
    text-align: center;
    padding-right: 22px;
    height: 38px;
}
.total_price {
    width: 30px;
    text-align: center;
    padding-right: 22px;
    height: 38px;
}
.total_summ {
    width: 30px;
    text-align: center;
    padding-right: 22px;
    height: 38px;
}
.total_tech {
    width: 30px;
    text-align: center;
    height: 38px;
}
.center {
    text-align: center;
    height: 38px;
}
.totat_tr {
    height: 38px;
}

.ol_num {
    width: 50px;
    text-align: center;
}

.ol_eq {
    width: 288px;
    max-width: 288px;
    padding-left: 22px;
    padding-right: 12px;
}

.ol_eq__select {
    width: 240px;
    max-width: 240px;
}

.ol_p_ctn {
    width: 217px;
    max-width: 217px;
    padding-left: 22px;
    padding-right: 12px;
}

.ol_p_ctn__select {
    width: 174px;
    max-width: 174px;
}

.ol_char {
    width: 205px;
    max-width: 205px;
    padding-left: 22px;
    padding-right: 12px;
}

.ol_char__select {
    width: 166px;
    max-width: 166px;
}

.ol_curr {
    width: 189px;
    max-width: 189px;
    padding-left: 22px;
    padding-right: 12px;
}

.ol_curr__select {
    width: 148px;
    max-width: 148px;
}

.ol_cnt {
    width: 128px;
    padding-left: 22px;
}

.ol_article {
    width: 172px;
    max-width: 172px;
    padding-left: 22px;
}

.ol_close {
    width: 46px;
    padding-left: 16px;
}

.summ_point {
    text-align: end;
    padding-right: 22px;
}

.summ_value {
    text-align: center;
    padding-right: 22px;
}

.modal_total table th, .modal_total table td, .modal_total table {
    border: none;
}
.modal_total thead {
    border-bottom: 1.5px solid #356EEF;
}
.modal_total tr {
    border-bottom: 1px solid #C8E4FF;
}
.modal_total tr:hover {
    background-color: #F0F8FF;
}
.modal_total .modal_header {
    border-bottom: none;
}

.summ_text {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 21px;
    color: #000000;
}

.next a {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;    
}

.cat_name {
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    color: #919299;
    background: none!important;
    padding: 0!important;
}

.description_modal .modal_header {
    border-bottom: none;

}

@media (max-width: 1190px) {
    .next {
        width: 120px!important;
    }
    .avr_tabs li {
        width: 100%;
        padding: 0;
        font-size: 14px;
        line-height: 22px;
    }
}

@media (max-width: 1180px) {
    .avr_header {
        flex-direction: column;
        gap: 20px;
    }
    .tab_content__header {
        flex-direction: column;
        gap: 15px;
        margin-bottom: 20px;
    }
    .avr_footer {
        flex-direction: column;
        align-items: start;
        gap: 40px;
    }
    .total_btns {
        justify-content: space-between;
        width: 100%;
    }
    .view_spec_btn, .download_spec {
        width: 50%;
    }
    .next {
        width: 120px!important;
    }
    .prev_btn {
        rotate: 180deg;
    }
}
@media (max-width: 960px) {
    .total_key {
        width: 30px;
    }
    .total_title {
        padding-top: 15px;
        padding-bottom: 15px;
        width: 280px;
    }
    .total_maker {
        width: 125px;
    }
    .total_count {
        width: 90px;
    }
    .total_od {
        width: 90px;
    }
    .total_price {
        width: 90px;
    }
    .total_summ {
        width: 90px;
    }
    .total_tech {
        width: 90px;
    }
    .line_table {
        overflow-x: scroll;
        -webkit-overflow-scrolling: auto;
    }
    .line_table table {
        width: 100%;
    }
}
@media (max-width: 450px) {
    .tab_content__header__row {
        flex-direction: column;
        gap: 15px;
    }
    .avr_footer {
        gap: 30px;
        margin-top: 30px;
    }
    .total_btns {
        flex-direction: column;
    }
    .view_spec_btn, .download_spec {
        width: 100%;
    }
    .avr_tabs li {
        font-size: 16px;
        line-height: 24px;
    }
    .avr_tabs li.active {
        height: 82px;
    }
    .modal_bottom {
        flex-direction: column-reverse;
        gap: 20px;
        text-align: center;
    }
    .avr_content {
        margin-top: 50px;
    }
    .modal_total {
        height: 655px;
        top: 350px;
    }
    .modal_total .modal_content {
        height: 355px;
    }
    .modal_bottom {
        padding-top: 25px;
    }
    .metal_constr_select, .avr_header .info_btn, .avr_footer .nominal_power, .avr_summ_btn, .avr_excel_btn{
        width: 100%;
    }
    .avr_header .info_btn {
        justify-content: center;
    }
    .tab_content {
        padding: 20px;
    }
    .modal_bottom__btns {
        flex-direction: column;
        gap: 20px;
    }
    .next {
        width: 90px!important;
    }
}
@media (max-width: 400px) {
    .modal_total {
        height: 666px;
    }
}
@media (max-width: 390px) {
    .modal_total {
        width: 330px;
    }
    .description_modal, .docs_modal {
        width: 330px;
    }
    .next {
        width: 75px!important;
    }
}
@media (max-width: 360px) {
    .next {
        width: 60px!important;
    }
}
@media only screen and (max-height: 740px) and (min-width: 1200px) {
    .modal_total {
        top: 360px;
    }
    .modal_total .modal_content {
        height: 370px;
    }
}

.commercial_offer_header {
    border-radius: 4px;
    background: rgba(200, 228, 255, 0.45);
    padding: 24px 16px;
    display: flex;
    justify-content: space-between;
    margin-top: 24px;
    cursor: pointer;
}
.commercial_offer_header_title {
    color: #1C1C1C;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 21px;
}
.commercial_offer_drop_row {
    rotate: 180deg;
}
.commercial_offer_body {
    padding: 0px 16px 24px 16px;
    background: rgba(200, 228, 255, 0.45);
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 4px;
}
.flex-row, .flex-group {
    display: flex;
    flex-direction: row;
    gap: 24px;
}
.customer_info .form_input {
    max-width: 100%;
}
.flex_form {
    width: 100%;
}
.form_grid {
    display: flex;
    flex-direction: column;
    gap: 24px;
    width: 100%;
}
.form_group {
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;
}
.form_label {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #000000;
    display: flex;
    align-items: center;
}
.form_input {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    padding: 10px 16px;
    background: #FFFFFF;
    border: 1px solid #CED4DA;
    border-radius: 4px;
    max-width: 200px;
    height: 100%;
}
.error_text {
    color: red;
}
.form_textarea {
    max-width: 100%;
    height: auto;
}
.textarea_container {
    position: relative;
}
.total_words {
    position: absolute;
    right: 5px;
    bottom: 5px;
    color: rgb(95,99,104);
    font-size: 14px;
}
.commercial_offer_body .form_textarea {
    resize: none;
    width: 100%;
}
.commercial_offer_order_btn {
    border-radius: 4px;
    background: #356EEF;
    width: 282px;
    height: 48px;
    padding: 8px 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #FFF;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    margin-top: 24px;
}
.commercial_offer_order_btn.disabled {
    background: #CED4DA;
}
.block_row {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
#close_offer {
    cursor: pointer;
}
.commercial_offer_order_title {
    color: #212529;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 27px;
    margin: 0px;
}
.commercial_offer_order {
    margin-top: 24px;
    border-radius: 4px;
    border-left: 4px solid #356EEF;
    background: #FFF;
    padding: 16px;
}
.commercial_offer_order_text {
    margin-top: 12px;
}
@media (max-width: 1200px) {
    .customer_info {
        flex-direction: column;
    }
    .form_input {
        width: 100%!important;
    }
}
@media (max-width: 600px) {
    .flex-row {
        flex-direction: column!important;;
    }
    .commercial_offer_order_btn {
        width: 100%;
    }
}
@media (min-width: 1600px) {
    .modal_total {
        top: 40%;
        height: auto;
    }
}
</style>
